import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import MethodHome from "./MethodHome";

export default function MethodList() {
  return (
      <Fragment>
            <Breadcrumbs mainTitle="List of Test Methods" parent="Home" title="List of Test Methods" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <MethodHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
